import React from "react";
import StoreSettingsForm from "./StoreSettingsForm";

// Business details, shipping, GST and payment setup of a website. The Super Admin (and staff allowed the settings)
// pick any website they reach from a searchable list; a store owner gets their own website, with a picker when they
// have more than one.
export default function StoreSettingsTab({ user, notify }) {
  const owner = user.role === "storeadmin";
  return (
    <>
      <div className="page-heading">
        <div>
          <p className="eyebrow">{owner ? "YOUR STORE" : "WEBSITES"}</p>
          <h1>Store settings</h1>
          <p className="subheading">{owner
            ? "Your business details, shipping charges, GST and how customers pay. Each website has its own."
            : "Pick a website, then update its business details, shipping, GST and payment setup. Each website has its own."}</p>
        </div>
      </div>
      <StoreSettingsForm notify={notify} allWebsites={!owner} />
    </>
  );
}
